import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowUpSquare: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconArrowUpSquare"><Path fillRule="evenodd" clipRule="evenodd" d="M21 21H3V3H21V21ZM7.58594 11L9 12.4141L11 10.4141V17H13V10.4141L15 12.4141L16.4141 11L12 6.58594L7.58594 11Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowUpSquare;
